//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";

export default {
  props: {
    article: {},
  },
  data() {
    return {
      dense: true,
      Suppliers: [],
      VatTypes: [],
      FilterVatTypes: [],
      Currencies: [],
    };
  },

  computed: {
    ...mapState("main", ["suppliers", "vatTypes", "currencies"]),
  },

  methods: {
    ...mapActions("main", []),

    getVatTypesFilter(val, update) {
      console.log("getVatTypesFilter", this.VatTypes);
      if (!this.VatTypes) {
        update();
        return;
      }

      update(() => {
        this.VatTypes = this.FilterVatTypes.filter(
          (v) =>
            v.name.toLowerCase().indexOf(val.toLowerCase()) > -1 &&
            v.visible &&
            !v.deleted &&
            (v.vatCodeGroupID == 9 || v.vatCodeGroupID == 8)
        );

        console.log("getVatTypesFilter update", this.VatTypes);
      });
    },
    async initSelectBox() {
      this.VatTypes = this.vatTypes;
      if (!this.VatTypes) {
        this.VatTypes = await this.getVatType();
      }
      this.FilterVatTypes = this.VatTypes;
    },
  },
  created() {
    this.Suppliers = this.suppliers;
    this.Currencies = this.currencies;
    this.initSelectBox();
  },
};
